var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 14 10",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.26.504a1 1 0 0 1 0 1.415l-7.072 7.07a1 1 0 0 1-1.414 0l-.011-.012-3.525-3.523A1 1 0 0 1 2.653 4.04l2.829 2.828L11.845.504a1 1 0 0 1 1.414 0Z",
  fill: "currentColor"
})));
export default SvgCheckmark;